import React from "react";
import { AlertTriangle, RefreshCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Localizer } from "@/main/react/Types";
import { DESTRUCTIVE_NOTICE_SURFACE_CLASS } from "@/main/react/component/destructiveNoticeSurface";

export function SearchErrorState(props: {
    query: string;
    localizer: Localizer;
    onRetry: () => void;
}) {
    const { query, localizer, onRetry } = props;

    return (
        <div className={`rounded-xl px-6 py-8 text-center ${DESTRUCTIVE_NOTICE_SURFACE_CLASS}`}>
            <div className="mx-auto flex size-14 items-center justify-center rounded-full bg-destructive/10 text-destructive-text">
                <AlertTriangle className="size-6" aria-hidden="true" />
            </div>

            <h3 className="mt-4 text-lg font-semibold text-foreground">{localizer("search.error.title")}</h3>
            <p className="mt-2 text-sm leading-6 text-muted-foreground">
                {query.trim() ? `${localizer("search.summary.results_for", query)}.` : localizer("search.summary.default")}
            </p>
            <p className="mt-2 text-sm text-muted-foreground">{localizer("search.error.description")}</p>

            <div className="mt-5 flex justify-center">
                <Button type="button" onClick={onRetry}>
                    <RefreshCcw className="size-4" />
                    {localizer("literal.retry")}
                </Button>
            </div>
        </div>
    );
}

export default SearchErrorState;
